import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";

const RENDER_PAGES_BREAK = 3;
const ICON_PREVIOUS = "<i class='icon-uni25C5'></i>";
const ICON_NEXT = "<i class='icon-uni25BB'></i>";
const CLASS_PAGE_LINK = "page-link";

export default class SearchPaging {
	constructor($container, $module, pagingData, eventManager) {
		this.eventManager = eventManager;
		this.pagingData = pagingData;
		this.$module = $module;
		this.$container = $container;
		this.numPages = Math.ceil(this.pagingData.total / this.pagingData.pageSize);

		this.render();

		const $activeMode = document.querySelector(".display-mode.active");
		if ($activeMode) {
			this.setDisplayMode($activeMode.dataset.mode, false);
		}
	}

	render() {
		const $pager = document.createElement("div");

		$pager.className = "item item__pager";

		if (this.pagingData.total > this.pagingData.pageSize) {
			$pager.innerHTML = "";
			this.addPageLinks(this.pagingData, $pager);
		}

		this.$container.querySelectorAll(".display-mode").forEach(
			function (anchor) {
				anchor.addEventListener(
					"click",
					function (event) {
						this.changeDisplayMode(event);
					}.bind(this),
				);
			}.bind(this),
		);

		const $filterContainer = this.$container.querySelector(".filters-cta");

		$filterContainer.append($pager);
	}

	changeDisplayMode(e) {
		e.preventDefault();
		const $selectedMode = e.currentTarget;
		const mode = $selectedMode.dataset.mode;
		const isActive = $selectedMode.classList.contains("active");
		this.setDisplayMode(mode, isActive);
	}

	setDisplayMode(mode, isActive) {
		if (!isActive) {
			document.querySelectorAll(".display-mode").forEach(function (element) {
				element.classList.remove("active");
			});
			document.querySelectorAll(`.display-mode[data-mode="${mode}"]`).forEach(function (element) {
				element.classList.add("active");
			});

			this.eventManager.trigger(events.search.CHANGE_DISPLAY_MODE, mode);
		}
	}

	addPageLinks(options, pager) {
		let from;
		let i;
		this.options = options;

		if (this.hasPrevious()) {
			const previousAnchor = this.createAnchor(CLASS_PAGE_LINK, this.options.currentPage - 1, ICON_PREVIOUS);
			pager.append(previousAnchor);
		}

		if (this.options.currentPage > 1) {
			if (this.options.currentPage === this.numPages) {
				from = this.options.currentPage > 2 ? this.options.currentPage - 2 : this.options.currentPage - 1;
			} else {
				from = this.options.currentPage - 1;
			}
		} else {
			from = 1;
		}

		for (i = from; i < Math.min(from + RENDER_PAGES_BREAK, this.numPages + 1); i = i + 1) {
			const currentAnchor = this.createAnchor(`page-link${this.options.currentPage === i ? " active" : ""}`, i, `<strong>${i}</strong>`);

			pager.append(currentAnchor);
		}

		if (this.hasNext()) {
			const nextAnchor = this.createAnchor(CLASS_PAGE_LINK, this.options.currentPage + 1, ICON_NEXT);
			pager.append(nextAnchor);
		}
	}

	createAnchor(classNames, dataPage, label) {
		const anchor = document.createElement("a");

		anchor.className = classNames;
		anchor.setAttribute("data-page", dataPage);
		anchor.innerHTML = label;

		return anchor;
	}

	bindPageLinks() {
		this.$container.querySelectorAll("a.page-link:not(.active)").forEach(($link) => {
			addListener($link, "click", this.gotoPage.bind(this));
		});
	}

	gotoPage(evt) {
		const targetPage = evt.currentTarget.dataset.page;
		this.eventManager.trigger(events.search.PAGE_CHANGED, { detail: { page: targetPage } });
	}

	hasNext() {
		return this.numPages > RENDER_PAGES_BREAK && this.options.currentPage < this.numPages;
	}

	hasPrevious() {
		return this.numPages > RENDER_PAGES_BREAK && this.options.currentPage > 1;
	}

	setPagerMarkup(markup) {
		this.$container.innerHTML = markup;
	}
}
